import styled from 'styled-components';

export const Logo = styled.img`
	display: block;
	width: 12.5rem;
	height: 3.9375rem;
	object-fit: contain;
`;

export const Subtitle = styled.span`
	display: block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.125rem;
	line-height: 1.5rem;
	letter-spacing: -0.0056rem;
`;

export const Title = styled.h2`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5625rem;
	font-weight: 600;
	line-height: 2rem;
	letter-spacing: -0.0078rem;
`;
